function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 1a6 6 0 100 12A6 6 0 007 1zm-.037 1.98a.75.75 0 110 1.5.75.75 0 010-1.5zm1.35 7.969H5.687a.525.525 0 010-1.05h.788v-3.45h-.6a.525.525 0 110-1.05h1.65v4.5h.787a.525.525 0 110 1.05z",
  fill: "currentColor"
});

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgInfo;